import { useContext } from "react"
import { CommandCenterStateProviderContext } from "../context";
import { Modals, ModalType } from "../types";


const useModals = () => {
    const context = useContext(CommandCenterStateProviderContext);

    if (context === undefined) {
        throw new Error('useModals must be used within a ModalProvider');
    }

    const { modals, set_Modals } = context

    const get_modal_details = (modal: ModalType) => {
        const selected_modal = modals.find((m: Modals) => m.name === modal)
        if (!selected_modal) {
            return {
                name: modal,
                open: false,
                pinned: false,
                current_modal: ''
            }
        } else {
            return selected_modal
        }
    }

    const close_modal = (modal: ModalType) => {
        if (!modals.length) return
        const filter_modals = modals.filter((m: Modals) => m.name !== modal)
        set_Modals(filter_modals)
    }

    const close_all_unpinned_modals = () => {
        const unpinned_modals = modals.filter((m: Modals) => !m.pinned)
        if (unpinned_modals.length === 0) return
        const pinned_modals = modals.filter((m: Modals) => m.pinned)
        set_Modals(pinned_modals)
    }

    const pinned_modal = (modal: ModalType) => {
        const filter_modals = modals.filter((m: Modals) => m.name !== modal)
        let selected_modal: Modals | undefined = modals.find((m: Modals) => m.name === modal)
        if (selected_modal) {
            selected_modal.pinned = !selected_modal.pinned
            selected_modal.current_modal = modal
        } else {
            selected_modal = {
                name: modal,
                open: true,
                pinned: true,
                current_modal: modal
            }
        }
        const updated_modals = [...filter_modals, selected_modal].map((m: Modals) => {
            if (m.name !== modal) {
                m.current_modal = ''
                return m
            } else {
                return m
            }
        })
        set_Modals(updated_modals)
    }

    const open_modal = (modal: ModalType) => {
        const filter_modals = modals.filter((m: Modals) => m.name !== modal)
        let selected_modal: Modals | undefined = modals.find((m: Modals) => m.name === modal)
        if (selected_modal) {
            selected_modal.open = true
            selected_modal.current_modal = modal
        } else {
            selected_modal = {
                name: modal,
                open: true,
                pinned: false,
                current_modal: modal
            }
        }
        const updated_modals = [...filter_modals, selected_modal].map((m: Modals) => {
            if (m.name !== modal) {
                m.current_modal = ''
                return m
            } else {
                return m
            }
        })
        set_Modals(updated_modals)
    }
    return { ...context, get_modal_details, close_modal, pinned_modal, open_modal, close_all_unpinned_modals }
}

export default useModals